import { FC } from 'react'
import { Button as MuiButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Loader } from 'packages/eid-ui'

export interface ButtonProps {
    onClick: any
    isInitialLoading?: boolean
    disabled?: boolean
    endIcon?: any
    children?: React.ReactNode
}

export const Button: FC<ButtonProps> = (props) => {
    const theme = useTheme()

    return (
        <MuiButton
            size="small"
            sx={{
                minWidth: '177px',
                height: '31px',

                border: `solid 1px ${theme?.palette?.primary?.main}}`,
                borderRadius: '16px',

                backgroundColor: theme?.palette?.background?.paper,
                color: theme?.palette?.primary?.main,

                boxShadow: '0 0 0 0',
                textTransform: 'capitalize',
            }}
            variant="outlined"
            onClick={props.onClick}
            disabled={props.disabled}
            endIcon={props.endIcon}
            tabIndex={0}
        >
            {props.isInitialLoading ? <Loader size={0.6} /> : props.children}
        </MuiButton>
    )
}
